import React from 'react'
import styled, { css } from 'styled-components'

const width = '23'
const height = '16'
const viewBox = '0 0 23 16'

const getDimensions = () => ({
  height,
  width
})

const getDimensionsCss = () => css`
  width: ${width}px;
  height: ${height}px;
`

const Image = styled.svg`
  ${({ noStyles }) => (!noStyles ? getDimensionsCss() : null)}
`

const defaultProps = {
  children: [
    <path
      fill="#FFF"
      fillRule="evenodd"
      d="M22.294 3.409s.206 1.808.206 3.618v1.669c0 1.809-.206 3.617-.206 3.617s-.207 1.53-.894 2.226c-.825.904-1.787.904-2.2.975-3.094.208-7.7.208-7.7.208s-5.706-.07-7.494-.208c-.481-.14-1.581-.07-2.406-.975-.688-.696-.894-2.226-.894-2.226S.5 10.505.5 8.696v-1.67C.5 5.218.706 3.41.706 3.41s.207-1.53.894-2.226C2.425.278 3.388.278 3.8.209 6.894 0 11.5 0 11.5 0s4.606 0 7.7.209c.413.07 1.375.07 2.2.974.688.695.894 2.226.894 2.226zM9.23 10.783l5.913-3.13L9.23 4.521v6.26z"
      key="key-0"
    />
  ],
  viewBox
}

export default Object.assign(Image, {
  getDimensions,
  getDimensionsCss,
  defaultProps,
  displayName: 'LogoSocialYoutube'
})
